module.exports = __webpack_public_path__ + "static/media/homeitem12.a5cd1b38.png";